/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteDocumentDto } from '../../models/delete-document-dto';
import { DocumentOperationResponseDto } from '../../models/document-operation-response-dto';

export interface DocumentsControllerDeleteDocument$Params {

/**
 * Tenant ID
 */
  tenant: string;

/**
 * Document unique identifier
 */
  documentId: string;
      body: DeleteDocumentDto
}

export function documentsControllerDeleteDocument(http: HttpClient, rootUrl: string, params: DocumentsControllerDeleteDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentOperationResponseDto>> {
  const rb = new RequestBuilder(rootUrl, documentsControllerDeleteDocument.PATH, 'delete');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('documentId', params.documentId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DocumentOperationResponseDto>;
    })
  );
}

documentsControllerDeleteDocument.PATH = '/thalea-documents/documents/{tenant}/{documentId}';
